import React from "react";
import { useSelector } from "react-redux";
import { Navigate, useLocation } from "react-router-dom";
import { RootState } from "../../../reducers";
import { hasAnyRole, adminRolesForEnv, allowedRolesForEnv } from "@ink-ai/portal/common/authHelper";

type RequireAdminProps = {
    children: React.ReactNode;
    redirectTo?: string;
};

const RequireAdmin: React.FC<RequireAdminProps> = ({ children, redirectTo = '/no-permission' }) => {
    const location = useLocation();
    const authState = useSelector((state: RootState) => state.auth);

    // If no group info in token, skip group check (Cognito or groups not configured)
    if (!authState.group) {
        return <>{children}</>;
    }

    const isAdmin = hasAnyRole(authState.group, adminRolesForEnv());
    if (!isAdmin) {
        return <Navigate to={redirectTo} state={{ from: location }} replace />
    }

    return <>{children}</>
}

export default RequireAdmin;
